

export const SplitByCharacter = (stringText : string, character : string) => {
    if( stringText.length >= 1){
        return stringText.split(character)
    }
}

export const RemoveExtraSpaces = (stringText: string) => {
  return stringText.trim().replace(/\s+/g, ' ')
}

export const SplitByCharacterWithPosition = (stringText : string, character : string, position = 0) => {
    if (stringText){
        if(stringText.length >= 1){
            return stringText.split(character)[position]
        }
    }
    return stringText
}